/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Embed_Export_Complete_ToastInputs */



/**
* | output |
* | --- |
* | "Audio embed export complete" |
*
* @param {Audio_Embed_Export_Complete_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_embed_export_complete_toast = /** @type {((inputs?: Audio_Embed_Export_Complete_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Embed_Export_Complete_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Exportation de l'intégration audio terminée")
	if (locale === "de") return /** @type {LocalizedString} */ ("Audio-Einbettungs-Export abgeschlossen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Esportazione del contenuto audio incorporata completata.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Экспорт встраивания аудио завершен.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Exportación de inserción de audio completada")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("音频嵌入导出完成")
	if (locale === "ja") return /** @type {LocalizedString} */ ("音声埋め込みのエクスポートが完了しました")
	if (locale === "hi") return /** @type {LocalizedString} */ ("ऑडियो एम्बेड निर्यात पूर्ण")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Exportação de áudio incorporado concluída")
	return /** @type {LocalizedString} */ ("Audio embed export complete")
});